import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { OffboardingCompartments, offboardingStorageKey } from '..';

export class OffboardingTemplateListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.PricebooksSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(offboardingStorageKey)
    private readonly cache: DataCache<OffboardingCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('offboardingTemplate');
        } else {
          this.cache.reset('offboardingTemplate');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
